import { Injectable } from '@angular/core';
import { IRelatedProductsCallback, RelatedProductsService } from '@df/catalog-ui/related-products/related-products.service';

export interface IManualEngineOptions {
    ids: number[];
}

@Injectable({
    providedIn: 'root'
})
export class ManualEngine {
    get(sourceIds: number[], callback: IRelatedProductsCallback, options: IManualEngineOptions) {
        callback(options.ids);
    }
}

RelatedProductsService.registerEngine('manual', ManualEngine);
